import type { SVGProps } from 'react'
const MyCasesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="13"
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.9 12.1004C1.515 12.1004 1.18542 11.9633 0.91125 11.6891C0.637083 11.415 0.5 11.0854 0.5 10.7004V2.30039C0.5 1.91539 0.637083 1.58581 0.91125 1.31164C1.18542 1.03747 1.515 0.900391 1.9 0.900391H13.1C13.485 0.900391 13.8146 1.03747 14.0887 1.31164C14.3629 1.58581 14.5 1.91539 14.5 2.30039V10.7004C14.5 11.0854 14.3629 11.415 14.0887 11.6891C13.8146 11.9633 13.485 12.1004 13.1 12.1004H1.9ZM1.9 10.7004H6.8V2.30039H1.9V10.7004ZM8.2 10.7004H13.1V2.30039H8.2V10.7004ZM8.9 8.60039H12.4V7.55039H8.9V8.60039ZM8.9 6.85039H12.4V5.80039H8.9V6.85039ZM8.9 5.10039H12.4V4.05039H8.9V5.10039Z"
      fill="#5E5E5E"
    />
  </svg>
)
export default MyCasesIcon
